export default __webpack_public_path__ + "static/media/empresas.9ebb3a84.png";